module.exports = __webpack_public_path__ + "static/media/panorama-h.3056fdf3.svg";